import React, { useCallback } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  Container,
  useTheme
} from '@mui/material';
import {
  ExitToApp as ExitToAppIcon,
  Home as HonmeIcon
} from '@mui/icons-material';
import { useDomain, DOMAINS } from '../../contexts/DomainContext';
import { useTheme as useCustomTheme } from '../../contexts/ThemeContext';
import { useTabs } from '../../contexts/TabContext';
import UseLogout from "../../hook/UseLogout";
import Swal from 'sweetalert2';
import './MobileLayout.css';

const MobileLayout = ({ children }) => {
  const theme = useTheme();
  const { domain, domainName } = useDomain();
  const { theme: themeMode, toggleTheme } = useCustomTheme();
  const { openTab } = useTabs();
  const isDarkMode = theme.palette.mode === 'dark';
  const { logoutProcess } = UseLogout();

  // 도메인별 색상 설정
  const getAccentColor = () => {
    if (domain === DOMAINS.PEMS) {
      return isDarkMode ? '#e67e22' : '#d35400';
    }
    return isDarkMode ? '#1976d2' : '#0a2351';
  };

  const handleMenuItemClick = (id) => {
    // 'home' 메뉴 클릭 시
    if (id === 'home') {
      openTab({ id: 'main', name: '메인' });
    }
    // '제품 관리' 메뉴 클릭 시
    else if (id === 'product-management') {
      openTab({ id: 'pi-product', name: '제품관리', group: 'pi' });
    }
    // '생산실적' 메뉴 클릭 시
    else if (id === 'production-result') {
      openTab({ id: 'pd-production-result', name: '생산실적등록', group: 'pd' });
    }
  };

  // 로그아웃 핸들러
  const handleLogout = useCallback(() => {
    Swal.fire({
      title: '로그아웃',
      text: '정말 로그아웃 하시겠습니까?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: theme.palette.primary.main,
      cancelButtonColor: theme.palette.grey[500],
      confirmButtonText: '로그아웃',
      cancelButtonText: '취소'
    }).then((result) => {
      if (result.isConfirmed) {
          logoutProcess();
      }
    });
  }, [theme.palette.primary.main, theme.palette.grey, logoutProcess]);

  return (
      <Box className="mobile-layout">
        <AppBar position="static" className="mobile-app-bar" sx={{
          backgroundColor: getAccentColor(),
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
          height: '64px',
          overflowY: 'auto'
        }}>
          <Toolbar sx={{ height: '100%' }}> {/* 헤더 기능 */}
            <Typography variant="h6" component="div" sx={{ flexGrow: 1, fontWeight: 600 }}>
              {domainName}
            </Typography>
            <IconButton color={"inherit"} button onClick={() => handleMenuItemClick('home')} sx={{ py: 2 }}>
                <HonmeIcon sx={{ fontSize: '2.5rem' }} />
            </IconButton>
            <IconButton button onClick={handleLogout} sx={{ py: 2 }}>
                <ExitToAppIcon sx={{ fontSize: '2.5rem', color: theme.palette.error.main }} />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Container sx={{
          py: 2,
          height: 'calc(100vh - 64px)',
          overflow: 'auto',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {children}
        </Container>
      </Box>
  );
};

export default MobileLayout;